"use client";
import Avatar from "@/components/General/Avatar";
import {formatDistance} from "date-fns";
import {fr} from "date-fns/locale";
import LikeButton from "@/components/SocialNetworks/Like/LikeButton";
import {useState} from "react";
import CommentForm from "@/components/SocialNetworks/Comment/CommentForm";
import Link from "next/link";
import CommentMenuEdit from "@/components/SocialNetworks/Comment/CommentMenuEdit";
import {urlify} from "@/lib/helpers/textHelper";

export default function CommentItem({id,comment, user, childs = false,createdAt,userId,likes,postId, parentId,actualUserId}){
    const isLike = likes.find(el => el.user_id === actualUserId);
    const [answer, setAnswer] = useState(false);
    return(
        <div className={"border rounded-lg p-2"}>
            <div className={"flex justify-between"}>
                <div className={"flex items-center gap-x-2 pb-2"}>
                    <Link href={`/profile/${user.id}`}>
                        <Avatar height={30} width={30} url={user.docs[0]?.path}/>
                    </Link>
                    <div>
                        <Link href={`/profile/${user.id}`}>
                            <p className={"font-medium hover:underline"}>{user.firstname} {user.lastname}</p>
                        </Link>
                        <p className={"text-xs"}>{formatDistance(Date.now(), new Date(createdAt), {locale: fr})}</p>
                    </div>
                </div>
                {user.id === actualUserId &&(
                    <CommentMenuEdit commentId={id} comment={comment}/>
                )}
            </div>

            <p className={"px-2"}>{comment ? urlify(comment, 'text-primary underline') : ''}</p>
            <div className={"flex justify-end items-center gap-x-3"}>
                <LikeButton type={"comments"} idType={id} minify={true} isLiked={isLike} numberLike={likes.length}/>
                <button className={`hover:underline ${answer ? 'text-primary underline' : ''}`}
                        onClick={() => setAnswer(!answer)}>Répondre
                </button>
            </div>
            {answer && (
                <div className={"p-5"}>
                    <CommentForm commentId={parentId} postId={postId}/>
                </div>
            )}
            {childs.length > 0 &&(
                <div className={"p-5 grid gap-2"}>
                    {childs.map(function(child){
                        return (
                            <CommentItem
                                key={child.id}
                                userId={userId}
                                user={child.user}
                                postId={postId}
                                createdAt={child.created_at}
                                comment={child.comment}
                                likes={child.likes}
                                id={child.id}
                                parentId={id}
                                actualUserId={actualUserId}
                            />
                        )
                    })}
                </div>
            )}
        </div>
    )
}